import {
  AfterContentInit,
  Component,
  ContentChildren,
  EventEmitter,
  HostBinding,
  Input, OnChanges,
  OnInit,
  Output,
  QueryList, SimpleChanges, ViewChild,
} from '@angular/core';
import {TemplateDirective} from '@catmodules/ui-base/directives/template/template.directive';
import {ExplorerItem, TreeNodeInfo} from '@catmodules/ui-base/types';
import * as lodash from "lodash";
import {ExplorerToolbarComponent} from "@catmodules/widgets/explorer/components/explorer-toolbar/explorer-toolbar.component";

const selectorName = 'cat-explorer';
const defaultClassNames = [selectorName].join(' ');
const unsetItem: ExplorerItem = {value: null, label: null, expanded: false, allowedActions: []};
const defaultMsgNoItemsFound = 'No items yet.';

@Component({
  selector: selectorName,
  styleUrls: ['./explorer.component.scss'],
  templateUrl: './explorer.component.html',
})
export class ExplorerComponent implements OnInit, AfterContentInit, OnChanges {
  @HostBinding('class') classNames = defaultClassNames;

  @Input() items: ExplorerItem[] = [];
  @Input() activeItem: ExplorerItem = unsetItem;
  @Input() displayCreate = false;
  @Input() displaySearchBox = false;
  @Input() noItemsFoundPlaceholder = defaultMsgNoItemsFound;
  @Input() enableSearch = true;
  @Input() doCustomNodeAction = false;
  @Input() customActiveItem = false;
  @Input() hoverDivGenerator: (nodeInfo: TreeNodeInfo) => HTMLDivElement | null = null;

  @Output() onActivate = new EventEmitter<ExplorerItem>();
  @Output() onAddOrCreate = new EventEmitter<ExplorerItem>();
  @Output() onSearchChanged = new EventEmitter<string>();
  @Output() onSearchBoxToggled = new EventEmitter<boolean>();

  @ContentChildren(TemplateDirective) templates: QueryList<any>;
  @ViewChild('explorerTolbar') explorerToolbar: ExplorerToolbarComponent;

  displayToolbar = false;
  templateMap = new Map<string, any>();
  itemsSearchBackup: ExplorerItem[] = null;

  cloneDeep = lodash.cloneDeep;

  ngOnInit() {
    this.displayToolbar = this.enableSearch || this.displayCreate;
    this.setSearchActive(this.displaySearchBox);

    // Add default RegExp search if no observer was given
    if (this.onSearchChanged.observers.length === 0) {
        this.onSearchChanged.subscribe( (value) => {
          if (value === "") {
            // Restore backup if search text is empty and backup is present
            if (this.itemsSearchBackup !== null) {
              this.items = this.itemsSearchBackup;
              this.itemsSearchBackup = null;
            }
          } else {
            // Try to build Regex - abort if not valid
            let regEx: RegExp;
            try {
              regEx = new RegExp(value, 'i');
            } catch (e) {
              return;
            }
            // Make backup at first search
            if (this.itemsSearchBackup === null) {
              this.itemsSearchBackup = this.cloneDeep(this.items);
            }
            // Perform search on copy of backup (needed for subsequent searches)
            this.items = this.cloneDeep(this.itemsSearchBackup).filter((item: ExplorerItem, index, array) => {
              return regEx.test(item.label);
            });
          }
        });
    }
  }

  ngAfterContentInit() {
    this.templates.forEach((item) => {
      this.templateMap.set(item.name, item.template);
    });
  }

  /**
   * Listens for data changes of items array and resets search
   * @param changes
   */
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.hasOwnProperty('items') && changes.items.hasOwnProperty('currentValue') && this.itemsSearchBackup !== null) {
      this.itemsSearchBackup = null;
      this.explorerToolbar.clearSearch();
    }
  }

  onClickItem(item: ExplorerItem) {
    this.onActivate.emit(item);
  }

  onClickAddOrCreate() {
    this.onAddOrCreate.emit();
  }

  onSearchHandler(value: string) {
    this.onSearchChanged.emit(value);
  }

  onSearchToggle(isActive: boolean) {
    this.setSearchActive(isActive);
    this.onSearchBoxToggled.emit(isActive);
  }

  protected setSearchActive(isActive: boolean) {
    const classNames = [defaultClassNames];
    if (isActive) {
      classNames.push('toolbar-extended');
    }
    // If search box was closed, restore search backup
    if (!isActive && this.itemsSearchBackup !== null) {
      this.items = this.itemsSearchBackup;
      this.itemsSearchBackup = null;
    }
    this.classNames = classNames.join(' ');
  }
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_release@2/app/Resources/Public/src/app/modules/widgets/explorer/components/explorer/explorer.component.ts